import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/joy/Box';
import Header from '../components/common/Header';
import Sidebar from '../components/common/Sidebar';

const MainLayout = () => {
  return (
    <Box sx={{
      display: 'flex',
      minHeight: '100vh',
      width: "100%",
      backgroundColor: 'var(--joy-palette-background-body)',
    }}>
      <Header />
      <Sidebar />
      <Box
        component="main"
        sx={{
          flex: 1,
          width: { xs: '100%', md: 'calc(100% - var(--Sidebar-width))' },
          maxWidth: { xs: '100%', md: 'calc(100% - var(--Sidebar-width))' },
          px: { xs: 2, sm: 3, md: 6 },
          py: { xs: "calc(var(--Header-height) + 24px)", md: 4 },
          display: "flex",
          flexDirection: "column",
          gap: 3,
          minHeight: "100dvh",
          backgroundColor: "var(--joy-palette-background-level1)",
          marginLeft: { xs: 0, md: "var(--Sidebar-width)" },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
